module.exports = __webpack_public_path__ + "static/email/img/icon_folder.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_folder.png
// module id = GAJb
// module chunks = 1